import * as yup from 'yup'

export const configDocumentSchema = yup.object().shape({
    CompaniaId: yup.string().required('La compañía es obligatorio'),
    ClienteId: yup.string().required('El cliente es obligatorio'),
    SiteId: yup.string().required('El site es obligatorio'),
    ValorBase: yup.string().when('ActivaExpresion', {
        is: false,
        then: yup.string().required('El valor base es obligatorio'),
        otherwise: yup.string()
    }),
    TipoDato: yup.string().when('ActivaExpresion', {
        is: false,
        then: yup.string().required('El tipo de dato es obligatorio'),
        otherwise: yup.string()
    }),
    Direccion: yup.string().when('ActivaExpresion', {
        is: false,
        then: yup.string().required('La dirección es obligatoria'),
        otherwise: yup.string()
    }),
    Expresion: yup.string().when('ActivaExpresion', {
        is: true,
        then: yup.string().required('La expresión es obligatoria'),
        otherwise: yup.string()
    }),
})
